import Query from "@qpr/client-api-base/querybuilder/Query";
import { getCurrentGlobalContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { IScoreCard } from "./model";

export const getRootScorecards = async () => {
  const rootModel = getCurrentGlobalContext().model;
  return Query("SC")
    .models({ criteria: `Find("${rootModel || ""}", name)` })
    .scorecard()
    .attributes("name", "level", "symbol")
    .fetchValues<IScoreCard>()
    .then((list) => list.filter((item) => item.level === "0"));
};
